import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import VisionaryArchitecture from "./sections/VisionaryArchitecture";
import LandmarkProjects from "./sections/LandmarkProjects";
import OurDisciplines from "./sections/OurDisciplines";
import TheArchiformaStandard from "./sections/TheArchiformaStandard";
import StartYourProject from "./sections/StartYourProject";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <VisionaryArchitecture />
      <LandmarkProjects />
      <OurDisciplines />
      <TheArchiformaStandard />
      <StartYourProject />
      <Footer />
    </div>;
}